"use strict";

function cov_akaoske95() {
  var path = "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/utils.js";
  var hash = "7b8e8c1c5632a3c59b531d173b6247df31cebf7d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/utils.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 5,
          column: 2
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 76
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 26
          },
          end: {
            line: 4,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 14
          }
        }, {
          start: {
            line: 3,
            column: 18
          },
          end: {
            line: 3,
            column: 45
          }
        }, {
          start: {
            line: 3,
            column: 49
          },
          end: {
            line: 3,
            column: 75
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b8e8c1c5632a3c59b531d173b6247df31cebf7d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_akaoske95 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_akaoske95();
cov_akaoske95().s[0]++;
module.exports = {
  isObjectWithValues: function isObjectWithValues(obj) {
    cov_akaoske95().f[0]++;
    cov_akaoske95().s[1]++;
    return (cov_akaoske95().b[0][0]++, obj) && (cov_akaoske95().b[0][1]++, Object.keys(obj).length > 0) && (cov_akaoske95().b[0][2]++, obj.constructor === Object);
  }
};